"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAvailabilities = exports.storeSlice = exports.storeInitialState = void 0;
const tslib_1 = require("tslib");
const index_1 = require("../../actions/store/refreshStoreData/index");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getStoreDetails_1 = require("../../actions/store/getStoreDetails");
const getQuerySearch_1 = require("../../actions/store/getQuerySearch");
const postInquiries_1 = require("../../actions/store/postInquiries");
const getAllItemsAvailabilities_1 = require("../../actions/store/getAllItemsAvailabilities");
const getMoreItemsSearch_1 = require("../../actions/store/getMoreItemsSearch");
const getItemsByDomain_1 = require("./../../actions/store/getItemsByDomain");
const getItemAvailability_1 = require("../../actions/store/getItemAvailability");
exports.storeInitialState = {
    data: {},
    loading: false,
    error: false,
    items: {
        data: [],
        loading: false,
        searchLoading: false,
        error: false,
        meta: {},
    },
    slices: {
        inquiry: {
            error: false,
            loading: false,
        },
        availability: {
            error: false,
            loading: false,
            data: [],
        },
    },
};
const combineExtraReducers = (builder) => {
    (0, getStoreDetails_1.getStoreDetailsExtraReducers)(builder);
    (0, index_1.refreshStoreDetailsExtraReducers)(builder);
    (0, postInquiries_1.postInquiryExtraReducers)(builder);
    (0, getAllItemsAvailabilities_1.getAllItemsAvailabilitiesExtraReducers)(builder);
    (0, getQuerySearch_1.getQuerySearchExtraReducers)(builder);
    (0, getMoreItemsSearch_1.getMoreItemsSearchExtraReducers)(builder);
    (0, getItemsByDomain_1.getItemsByDomainExtraReducers)(builder);
    (0, getItemAvailability_1.getItemAvailabilityExtraReducers)(builder);
};
exports.storeSlice = toolkitRaw.createSlice({
    name: 'store',
    initialState: exports.storeInitialState,
    reducers: {
        resetAvailabilities: (state) => {
            state.slices.availability.data = [];
        },
    },
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
exports.resetAvailabilities = exports.storeSlice.actions.resetAvailabilities;
exports.default = exports.storeSlice.reducer;
//# sourceMappingURL=index.js.map